/*eslint-disable*/

import React from "react";
import "../css/company.css";
import useObserver from "../useHooks/useObserver";

function Company() {
  const ioRef = useObserver();

  window.addEventListener("scroll", function () {
    this.scrollY > 200
      ? $(".topBtn").addClass("on")
      : $(".topBtn").removeClass("on");
  });

  const moveTop = () => {
    document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div className="comTop" ref={ioRef}>
        COMPANY
      </div>

      <div className="topBtn" onClick={moveTop}></div>
    </div>
  );
}

export default Company;
